export default "__VITE_ASSET__DC0wBr3$__"